import Row from './Row';
import { handleTeamSettingsModalProps } from '../teamTableTypes';

export default function RowList({
  rows,
  colKey,
  level,
  handleTeamSettingsModal,
  lastVisibleName,
}: {
  rows: any;
  colKey: string;
  level: number;
  handleTeamSettingsModal?: handleTeamSettingsModalProps;
  lastVisibleName?: string;
}) {
  return rows.map((row: any) => {
    const subRows =
      row.subTeams?.map((item: any, index: number) => {
        switch (colKey) {
          case 'TEAM':
            return { ...item, subTeams: item.subTeams || [] };
          case 'MEMBERS':
            return {
              ...item.teamMetaData,
              name: item.name,
              subTeams: item.subTeams || [],
              subTeamsList: item.teamMetaData?.subTeams || [],
            };
          case 'DROPDOWN':
            return {
              ...item,
              // last child within its immediate siblings
              isLast: row.subTeams?.length === index + 1,
              // very last visible node in the whole expanded tree
              isLastLastChild:
                lastVisibleName !== undefined && item.name === lastVisibleName,
              subTeams: item.subTeams || [],
            };
          default:
            return [];
        }
      }) || [];
    return (
      <Row
        level={level}
        key={`${row.name}-${colKey}`}
        cellData={row}
        colKey={colKey}
        subRows={subRows || []}
        handleTeamSettingsModal={handleTeamSettingsModal}
        lastVisibleName={lastVisibleName}
      />
    );
  });
}
